import React, { Component } from 'react';
import { Input, Select, DatePicker, Space, Upload, message, Table } from 'antd';

export const TableContainer = ({ columns, data, ...restProps }) => {

    return (
        <div className='table_container'>
            <Table
                {...restProps}
                rowClassName={(record, index) => {
                    let className = 'table_row';
                    return className;
                }}
                bordered={true}
                columns={columns}
                dataSource={data}
                // pagination={{
                //     showTotal: total => `共 ${total} 条`,
                //     showQuickJumper: true,
                //     position: ['bottomCenter'],
                //     pageSize: 10,
                //     // pageSizeOptions:['10'],
                //     // size: 'small',
                //     showSizeChanger: false,
                //     hideOnSinglePage: true
                // }}
                scroll={{
                    x: 1500,
                    // y: 500,
                }}
            />
        </div>
    )
}

export const WrapContainer = ({ title, addEditBtn = () => { }, children }) => {

    return (
        <div className='wrap_container'>
            <div className="wrap_header">
                <div className="header_title">{title}</div>
                {addEditBtn(title)}
            </div>
            <div className="wrap_content">
                {children}
            </div>
        </div>
    )
}

export const ShowBaseInfo = ({ data }) => {

    return (
        <div className="echo_form_content">
            <ul className='base_info_list'>
                {
                    data && data.map(({ label, value }) => {
                        return (value
                            ? <li className='base_info_item' key={label}>
                                <div className='form_echo'>
                                    <span className="form_label_echo" >{label}:</span>
                                    <span className="form_item_echo">{value}</span>
                                </div>
                            </li>
                            : ''
                        )
                        
                    })
                }
            </ul>
        </div>
    )
}

export const ShowBaseInfo2 = ({ data }) => {

    return (
        <div className="echo_form_content">
            <div className='evaluation_items'>
                {
                    data && data.map(({ label, value }) => {
                        return (value
                            ? <div className='form_echo4' key={label}>
                                <span className="form_label_echo" >{label}:</span>
                                <span className="form_item_echo">{value}</span>
                            </div>
                            : ''
                        )
                    })
                }
            </div>
        </div>
    )
}
